import { isArray } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import ModalWindow from '../../common/Modal';
import Button from '../../common/Button';

import styles from './DownloadReportModal.module.scss';

function DownloadReportModal(props) {
  const { onClose } = props;
  let text = 'The report will be sent to your email shortly';

  if (isArray(props.text)) {
    text = props.text.map((text, index) => <span key={index}>{text}</span>);
  } else if (props.text) {
    text = props.text;
  }

  return (
    <ModalWindow open={props.open} onClose={onClose} center>
      <div className={styles.body}>
        <h3>{text}</h3>
        <div className={styles.footer}>
          <Button onClick={onClose} text="OK" />
        </div>
      </div>
    </ModalWindow>
  );
}

export default DownloadReportModal;

DownloadReportModal.defaultProps = {
  open: false,
};

DownloadReportModal.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
